export default class Base {
  protected eventTarget: EventTarget;
  protected eventListeners: Map<string, Set<EventListener>>;

  constructor() {
    this.eventTarget = new EventTarget();
    this.eventListeners = new Map();
  }

  // カスタムイベントリスナーの追加
  public addEventListener(
    type: string,
    listener: EventListener,
    options?: boolean | AddEventListenerOptions
  ): void {
    this.eventTarget.addEventListener(type, listener, options);

    // リスナーを追跡
    if (!this.eventListeners.has(type)) {
      this.eventListeners.set(type, new Set());
    }
    this.eventListeners.get(type)!.add(listener);
  }

  // カスタムイベントリスナーの削除
  public removeEventListener(
    type: string,
    listener: EventListener,
    options?: boolean | EventListenerOptions
  ): void {
    this.eventTarget.removeEventListener(type, listener, options);

    // 追跡からも削除
    const listeners = this.eventListeners.get(type);
    if (listeners) {
      listeners.delete(listener);
      if (listeners.size === 0) {
        this.eventListeners.delete(type);
      }
    }
  }

  // カスタムイベントリスナーの全削除
  public removeAllEventListeners(): void {
    // すべてのイベントタイプに対してリスナーを削除
    this.eventListeners.forEach((listeners, type) => {
      listeners.forEach((listener) => {
        this.eventTarget.removeEventListener(type, listener);
      });
    });

    // 追跡をクリア
    this.eventListeners.clear();
  }

  // イベントの発火
  protected dispatchEvent(event: Event): boolean {
    return this.eventTarget.dispatchEvent(event);
  }
}
